module.exports = __webpack_public_path__ + "img/ico-like02.217ef23b.svg";